import ScrollableWrap from './ScrollableWrap';

export default ScrollableWrap;
